import AvatarWidget from "../../components/users/AvatarWidget.tsx";
import { Button, Stack, Typography } from "@mui/material";
import { W2d2dNavigation } from "../../../W2d2dNavigation.tsx";
import { useCallback } from "react";
import { Invitation, w2d2dApiClient } from "../../../w2d2d-api-client.ts";
import { useLocation, useNavigate } from "react-router-dom";
import FullSizeBox from "../../../../appfw/ui/components/FullSizeBox.tsx";
import { useUser } from "../../../../appfw/users/User.tsx";
import { useConnectionsControl } from "../../hooks/useConnectionsControl.tsx";

interface JoinInvitationProps {
    readonly invitation: Invitation;
}

export default function JoinInvitation(props: JoinInvitationProps) {

    const navigate = useNavigate()
    const location = useLocation()

    const inviterHook = useUser(props.invitation.inviterId)

    const { refreshConnections } = useConnectionsControl()

    const handleClickAccept = useCallback(async () => {
        await w2d2dApiClient.acceptInvitation({ invitationId: props.invitation.id })
        await refreshConnections()
        W2d2dNavigation.connections.navigate(navigate, location)
    }, [props.invitation, navigate, location, refreshConnections])

    return (
        <FullSizeBox centerVertically={true}>
            <AvatarWidget id={props.invitation.inviterId} size={64} />
            <Typography variant="h6" sx={{
                margin: 1,
            }}>
                {inviterHook.data?.name}
            </Typography>

            <Typography variant="h6" sx={{
                margin: 2,
            }}>
                Möchte sich mit Dir verbinden
            </Typography>
            <Stack
                direction="row"
                spacing={2}
            >
                <Button onClick={handleClickAccept}>
                    Akzeptieren
                </Button>
                <Button
                    onClick={() => W2d2dNavigation.connections.navigate(navigate, location)}
                >
                    Ablehnen
                </Button>
            </Stack>
        </FullSizeBox>
    )
}